{
  "captureBulkDeleteDialog": {
    "text": "削除中...",
    "title": "{{length}}件を削除しますか？",
    "text2": "この操作は元に戻せません。続行しますか？",
    "text3": "選択件数:",
    "text4": "件",
    "text5": "削除対象:",
    "text6": "(無題)",
    "error": "未対応の種別です: {{recordType}}"
  },
  "captureDeleteDialog": {
    "text": "削除に失敗しました",
    "text2": "削除中...",
    "title": "削除しますか？",
    "text3": "この操作は元に戻せません。続行しますか？",
    "text4": "タイトル:",
    "text5": "記録期間:"
  },
  "captureEditDialog": {
    "required": "タイトルを入力してください",
    "max": "タイトルは255文字以下で入力してください",
    "max2": "メモは1000文字以下で入力してください",
    "clip": "ムービー",
    "snapshot": "スナップショット",
    "timelapse": "タイムラプス",
    "handsRecord": "Hands録画",
    "error": "CaptureEditDialog: hands_record の編集は未対応",
    "text": "更新中...",
    "alert": "読み込みに失敗しました",
    "label": "タイトル",
    "label2": "メモ",
    "label3": "エリア名",
    "label4": "カメラ名",
    "label5": "作成日時",
    "label6": "作成者",
    "label7": "種別",
    "label8": "サイズ"
  },
  "captureFilterBar": {
    "label": "すべて",
    "label2": "ムービー",
    "label3": "タイムラプス",
    "label4": "スナップショット",
    "label5": "Hands録画",
    "label6": "処理中",
    "label7": "再生可能",
    "label8": "失敗",
    "placeholder": "タイトル・カメラ名・エリア名で検索",
    "button": "フィルタ",
    "label9": "作成日",
    "label10": "カメラ",
    "label11": "種別",
    "label12": "ステータス"
  },
  "captureTable": {
    "processing": "処理中",
    "completed": "再生可能",
    "failed": "失敗",
    "removed": "削除済",
    "clip": "ムービー",
    "snapshot": "スナップ",
    "timelapse": "タイムラプス",
    "text": "件選択中",
    "label": "タイトル",
    "label2": "カメラ名",
    "label3": "記録期間",
    "label4": "作成日時",
    "label5": "ステータス",
    "label6": "サイズ",
    "label7": "再作成",
    "label8": "ダウンロード",
    "text2": "閲覧可能なキャプチャはありません"
  },
  "captureView": {
    "showSnackbar": "エラー",
    "showSnackbar2": "ダウンロード URL を取得できませんでした",
    "showSnackbar3": "ダウンロードに失敗しました",
    "showSnackbar4": "Hands録画の ID を取得できませんでした",
    "showSnackbar5": "{{length}}件を削除しました",
    "showSnackbar6": "一括削除に失敗しました",
    "showSnackbar7": "{{length}}件を削除しました（{{length2}}件失敗）",
    "title": "キャプチャ一覧",
    "showSnackbar8": "更新に失敗しました",
    "showSnackbar9": "更新しました",
    "text": "削除に失敗しました",
    "showSnackbar10": "削除が完了しました"
  },
  "clipDeleteDialog": {
    "text": "クリップの削除に失敗しました",
    "text2": "削除中...",
    "title": "クリップを削除しますか？",
    "text3": "この操作は元に戻せません。続行しますか？",
    "text4": "タイトル:",
    "text5": "収録時間:"
  },
  "clipEditDialog": {
    "required": "タイトルを入力してください",
    "max": "タイトルは255文字以下で入力してください",
    "text": "動画",
    "text2": "タイムラプス",
    "enqueueSnackbar": "クリップを更新しました",
    "enqueueSnackbar2": "クリップの更新に失敗しました",
    "text3": "更新中...",
    "title": "クリップ編集",
    "label": "タイトル",
    "label2": "管理番号",
    "label3": "収録時間",
    "label4": "容量",
    "label5": "エリア名",
    "label6": "カメラ名",
    "label7": "作成日時",
    "label8": "作成者",
    "label9": "種別",
    "label10": "倍率",
    "value": "{{timelapseSpeedRate}}倍"
  },
  "clipFilterBar": {
    "label": "すべて",
    "label2": "リクエスト済",
    "label3": "作成中",
    "label4": "アップロード中",
    "label5": "再生可能",
    "label6": "作成失敗",
    "placeholder": "タイトル・カメラ名・エリア名で検索",
    "button": "フィルタ",
    "label7": "作成日",
    "label8": "カメラ",
    "label9": "ステータス"
  },
  "clipPagination": {
    "text": "件"
  },
  "clipRestartDialog": {
    "enqueueSnackbar": "タイムラプスの再作成は現在サポートされていません",
    "enqueueSnackbar2": "クリップ動画の再作成を行いました",
    "enqueueSnackbar3": "クリップの再作成中にエラーが発生しました",
    "text": "再作成中...",
    "text2": "再作成",
    "title": "クリップを再作成しますか？",
    "text3": "以下のクリップを再作成します。",
    "text4": "タイトル:",
    "text5": "収録時間:"
  },
  "clipTable": {
    "requested": "リクエスト済",
    "creating": "作成中",
    "created": "作成完了",
    "uploading": "アップロード中",
    "uploaded": "再生可能",
    "failed": "失敗",
    "text": "ムービー",
    "text2": "タイムラプス",
    "text3": "件選択中",
    "label": "カメラ名",
    "label2": "クリップ期間",
    "label3": "作成日時",
    "label4": "ステータス",
    "label5": "ファイルサイズ",
    "label6": "再作成",
    "label7": "ダウンロード",
    "text4": "閲覧可能なクリップはありません"
  },
  "clipVideoPlayerDialog": {
    "ariaLabel": "シーク",
    "ariaLabel2": "音量",
    "text": "ノーマル",
    "text2": "{{speed}}倍",
    "title": "ダウンロード",
    "title2": "ピクチャー イン ピクチャー"
  },
  "snapshotPreviewDialog": {
    "text": "ダウンロード中...",
    "text2": "ダウンロード",
    "text3": "スナップショット",
    "text4": "アップロード処理中です。完了次第このダイアログに表示されます。",
    "text5": "アップロード完了を確認できませんでした。",
    "text6": "時間をおいて再度お試しください。",
    "button": "もう一度読み込む",
    "text7": "ダウンロードに失敗しました",
    "text8": "メモ:",
    "text9": "カメラ:",
    "text10": "撮影日時:"
  },
  "useCameraOptions": {
    "text": "エリア不明"
  },
  "useCapturesTabs": {
    "label": "全て",
    "label2": "アーカイブ"
  },
  "useCapturesUsageText": {
    "text": "{{totalCount}}件",
    "text2": "{{totalCount}}件(合計使用容量 {{value}} / {{value2}})",
    "text3": "{{totalCount}}件(合計使用容量 {{value}})"
  },
  "useClipTabs": {
    "label": "全て",
    "label2": "アーカイブ"
  },
  "useClipUsageText": {
    "text": "{{filteredCount}}件(合計使用容量 {{value}} / {{value2}})",
    "text2": "{{filteredCount}}件(合計使用容量 {{value}})"
  }
}
